import React from "react";
import { Link } from "react-router-dom";
// componentes y estilos de Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation'; // Si quieres las flechitas
import 'swiper/css/pagination'; // Si quieres los puntitos abajo
// módulos de funcionalidad
import { Navigation, Pagination } from 'swiper/modules';
import './additional-services.css'
import { useTranslation } from "react-i18next";

import imgAdditional from '../../../../assets/imgs/home-redesign/additional.svg';
import iconEntrega from '../../../../assets/imgs/home-redesign/entrega.svg';
import iconEmpaque from '../../../../assets/imgs/home-redesign/empaque.svg';
import iconAlmacenaje from '../../../../assets/imgs/home-redesign/almacenaje.svg';
import iconValuacion from '../../../../assets/imgs/home-redesign/valuacion.svg';
import { FaLongArrowAltLeft, FaLongArrowAltRight } from "react-icons/fa";

const AdditionalServices = () => {
    const [tAdditional] = useTranslation("additionalServPage");
    const cardsData = [
        { icon: iconEntrega, title: tAdditional("home-delivery.title"), text: tAdditional("home-delivery.description") },
        { icon: iconEmpaque, title: tAdditional("packaging.title"), text: tAdditional("packaging.description")},
        { icon: iconAlmacenaje, title: tAdditional("storage.title"), text: tAdditional("storage.description")},
        { icon: iconValuacion, title: tAdditional("valuation.title"), text: tAdditional("valuation.description")},
    ];

    return(
        <div className="container-fluid additional-services">
            <div className="row">
                <div className="col title-additional">
                    <img src={imgAdditional} />
                    <h3>{tAdditional("header.title")}</h3>
                </div>
            </div>

            <div className="additional-services-desktop">
                <div className="row mt-4 g-0">
                    {cardsData.map((card, index) => (
                        <div key={`main-${index}`} className="col-3 d-flex">
                            <div className="card-additional-home">
                                <div className="mb-3">
                                    <div className="card-additional-title">
                                        <img src={card.icon} alt={card.title} />
                                        <h5 className="align-self-end">{card.title}</h5>
                                    </div>
                                    <div className="card-additional-text">
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html: card.text.replace(/\n/g, "<br />")
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="row">
                    <div className="col text-center mt-4">
                        <Link
                            to='/servicios/servicios-adicionales' 
                            className="btn-tertiary text-decoration-none"
                        >
                            {tAdditional("btn-more")}
                        </Link>
                    </div>
                </div>
            </div>

            <div className="additional-services-tablet custom-padding">
                <div className="row">
                    <div className="col my-4 position-relative">

                        <div className="custom-prev-ad nav-btn-ad">
                            <FaLongArrowAltLeft size={18} />
                        </div>
                        <div className="custom-next-ad nav-btn-ad">
                            <FaLongArrowAltRight size={18} />
                        </div>

                        <Swiper
                            modules={[Navigation]}
                            spaceBetween={0} // Espacio entre cards (en px)
                            navigation={{
                                nextEl: '.custom-next-ad',
                                prevEl: '.custom-prev-ad',
                            }}
                            breakpoints={{
                                // Configuración para Celular (>= 320px)
                                320: {
                                    slidesPerView: 1, // Muestra 1 card
                                    spaceBetween: 10
                                },
                                // Configuración para Tablet (>= 768px)
                                768: {
                                    slidesPerView: 2, // Muestra 2 cards (¡Lo que pediste!)
                                    spaceBetween: 20
                                }
                            }}
                            className="mySwiper"
                        >
                            {/* Aquí iteramos TODAS las cards, sin separar en grupos */}
                            {cardsData.map((card, index) => (
                                <SwiperSlide key={index} style={{ height: 'auto' }}>
                                    {/* El 'height: auto' en el slide es clave para que Flexbox funcione dentro */}
                                    <div className="card-additional-home"> 
                                        <div className="mb-0">
                                            <div className="card-additional-title">
                                                <img src={card.icon} alt={card.title} />
                                                <h5 className="align-self-end text-nowrap">{card.title}</h5>
                                            </div>
                                            <div className="card-additional-text">
                                                <p
                                                    dangerouslySetInnerHTML={{
                                                        __html: card.text.replace(/\n/g, "<br />")
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
                <div className="row">
                    <div className="col text-center mb-1">
                        <Link
                            to='/servicios/servicios-adicionales' 
                            className="btn-tertiary text-decoration-none"
                        >
                            {tAdditional("btn-more")}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdditionalServices;